import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMinor = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_3425_4296)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M3.75 20.25V4.5H21L16.5 10.125L21 15.75H3.75",
			fill: "#177400",
			fillOpacity: .1
		}), /* @__PURE__ */ _jsx("path", {
			d: "M3.75 20.25V4.5H21L16.5 10.125L21 15.75H3.75",
			stroke: "#177400",
			strokeWidth: 2.9375,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_3425_4296",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgMinor;
